import MenuButton from "../menuButton";
import LogoButton from "./logoButton";

const Header = ({ onClick }) => {
  const base =
    "absolute top-0 left-1/2 -translate-x-1/2 z-[2] w-full h-[70px] md:h-[100px] max-w-1440 mx-auto px-smallMobile md:px-mediumDesktop flex justify-between items-center bg-dune";
  return (
    <nav className={base}>
      <MenuButton onClick={onClick} textColor="olive" />
      <LogoButton />
      <MenuButton name="Book & Join" link="/book-join" textColor="olive" />
    </nav>
  );
};

export default Header;
